module.exports = __webpack_public_path__ + "img/task-11-g.ce50453b.png";